import { useContext } from "react";
import OrderButton from "../order-button/order-button";
import CheckoutContext from "../../checkout-context";

export function StepsNavigation({ hasBackToCartLink = true }) {
  const {
    currentStep,
    lastStep,
    backToCartLink,
    textsMapping,
    goToStep,
    handleOrderConfirm,
    isOrderButtonLoading,
  } = useContext(CheckoutContext);

  const renderPrevButton = () => {
    const firstStepIsActive = currentStep === 0;

    if (firstStepIsActive) {
      if (hasBackToCartLink) {
        return (
          <a href={backToCartLink} className="button">
            {textsMapping.checkoutNavigationBackToCart}
          </a>
        );
      }

      return null;
    }

    return (
      <button type="button" onClick={() => goToStep("prev")}>
        {textsMapping.checkoutNavigationPrevious}
      </button>
    );
  };

  const renderNextButton = () => {
    const lastStepIsActive = currentStep === lastStep;

    if (lastStepIsActive) {
      return (
        <OrderButton
          textsMapping={textsMapping}
          onOrderClick={handleOrderConfirm}
          isLoading={isOrderButtonLoading}
        />
      );
    }

    return (
      <button type="button" onClick={() => goToStep("next")}>
        {textsMapping.checkoutNavigationNext}
      </button>
    );
  };

  return (
    <div className="multi-step__navigation-wrapper">
      <div className="multi-step__navigation">
        <div className="multi-step__navigation-prev">{renderPrevButton()}</div>
        <div className="multi-step__navigation-next">{renderNextButton()}</div>
      </div>
    </div>
  );
}
